// extracted by mini-css-extract-plugin
export default {"error-msg":"ErrorMessage_error-msg__KjDm1"};